import { gql, useMutation } from '@apollo/client'
import cx from 'classnames'
import rollbar from 'helpers/rollbar'
import { useToast } from './Toast'
import { ArchiveResultMutation, ArchiveResultMutationVariables } from './__generated__/ArchiveResultMutation'

const archiveResultMutation = gql`
  mutation ArchiveResultMutation($id: ID!) {
    archiveResult(resultId: $id) {
      result {
        id
        status
        queueName
      }
    }
  }
`

interface ArchiveResultButtonProps {
  resultId: string
  children: React.ReactNode
  className?: string
}

const ArchiveResultButton = ({ resultId, children, className }: ArchiveResultButtonProps) => {
  const { addToast } = useToast()

  const [archiveResult, { loading }] = useMutation<ArchiveResultMutation, ArchiveResultMutationVariables>(
    archiveResultMutation
  )

  const onArchive = async () => {
    try {
      await archiveResult({
        variables: { id: resultId },
      })

      addToast({
        messageType: 'success',
        title: 'Archived',
        content: `Result archived`,
        timeout: 3000,
      })
    } catch (err) {
      rollbar.error('Error archiving result', err)
      addToast({
        messageType: 'error',
        title: 'Error',
        content: `Failed archive result: ${err.message}`,
      })
    }
  }

  return (
    <button
      type="button"
      className={cx(className, 'button is-small is-outlined is-fullwidth', {
        'is-loading': loading,
      })}
      onClick={onArchive}
    >
      {children}
    </button>
  )
}

export default ArchiveResultButton
